/**
 * Vocabulario de estados y prioridades del portal.
 *
 * Estos diez estados son los definidos en docs/03-modelo-datos.md y son la
 * única fuente de verdad del vocabulario: la base de datos los replica como
 * enums de PostgreSQL y la UI toma de aquí sus etiquetas y su orden.
 */
export const WORK_STATES = [
    'backlog',
    'ready',
    'in_development',
    'in_review',
    'in_testing',
    'ready_for_prod',
    'in_production',
    'blocked',
    'done',
    'cancelled',
];
/** Etiquetas en español, tal como se muestran en el Kanban. */
export const WORK_STATE_LABELS = {
    backlog: 'Backlog',
    ready: 'Lista para trabajar',
    in_development: 'En desarrollo',
    in_review: 'En revisión',
    in_testing: 'En pruebas',
    ready_for_prod: 'Lista para producción',
    in_production: 'En producción',
    blocked: 'Bloqueada',
    done: 'Completada',
    cancelled: 'Cancelada',
};
/**
 * Avance que aporta cada estado al progreso derivado.
 * Ver la fórmula de progress_pct en docs/03-modelo-datos.md.
 */
export const WORK_STATE_PROGRESS = {
    backlog: 0,
    ready: 0,
    blocked: 0,
    cancelled: 0,
    in_development: 0.2,
    in_review: 0.4,
    in_testing: 0.6,
    ready_for_prod: 0.8,
    in_production: 1,
    done: 1,
};
/** Estados que no cuentan como trabajo pendiente. */
export const CLOSED_STATES = ['done', 'in_production', 'cancelled'];
export const PRIORITIES = ['P0', 'P1', 'P2', 'P3'];
/** Peso de cada prioridad en el progreso derivado: cerrar un P0 pesa más. */
export const PRIORITY_WEIGHT = { P0: 4, P1: 3, P2: 2, P3: 1 };
export const ITEM_KINDS = ['feature', 'task', 'bug'];
export const ITEM_KIND_LABELS = {
    feature: 'Funcionalidad',
    task: 'Tarea',
    bug: 'Error',
};
export const PROJECT_STATUSES = [
    'planning',
    'active',
    'blocked',
    'paused',
    'maintenance',
    'archived',
];
export const PROJECT_STATUS_LABELS = {
    planning: 'En planificación',
    active: 'Activo',
    blocked: 'Bloqueado',
    paused: 'Pausado',
    maintenance: 'Mantenimiento',
    archived: 'Archivado',
};
export const ENV_KINDS = ['production', 'staging', 'demo', 'development'];
/**
 * Procedencia de un registro. Es lo que permite resincronizar el espejo de
 * GitHub sin destruir el trabajo propio del portal.
 */
export const ORIGINS = ['github', 'portal', 'derived'];
//# sourceMappingURL=states.js.map